import * as req from 'api/actions';
import * as c from './constant';

export const getList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_assessments`,
    payload,
    callback
  );

export const getCodedValueList = (payload, callback) =>
  req.list(
    c.GET_CODED_VALUE_LIST,
    '/api/v1/rpt/administrator/settings/tax_exempt_codes?status=1',
    payload,
    callback
  );

export const updateMachineryPropertyAssessmentTaxability = (
  id,
  propertAssessmentId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_MACHINERY_PROPERTY_ASSESSMENT_TAXABILITY,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_assessments/${propertAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );
